import React, { useState } from 'react';
import { getTagManager } from '../../services/gtmEvents';
import Observer from '@researchgate/react-intersection-observer';

const Footer = ({ footerData }) => {
  const [footerComponent, setFooterComponent] = useState({});
  const envCountry = process.env.RAZZLE_LANGUAGE || window.env.RAZZLE_LANGUAGE;

  const handleChange = async (event, unobserve) => {
    if (event.isIntersecting) {
      unobserve();
      addView();
    }
  }

  const addView = async () => {
    const loadedComponent = {};
    import('agrofy-ui-components')
      .then(({ AgroFooterV2, AgroReducedFooter }) => {
        loadedComponent['Footer'] = <>
          <AgroFooterV2
            footerData={footerData.footer}
            tagManager={(dataLayerEvent) => { getTagManager().dataLayer(dataLayerEvent) }}
          />
          <AgroReducedFooter
            footerData={footerData.reducedFooter}
            variant='default'
            language={envCountry}
          /></>
        setFooterComponent({ ...footerComponent, ...loadedComponent });
      });
  }

  return (
    <Observer {...{ onChange: handleChange, rootMargin: '400px', threshold: 0.1 }}>
      <div style={{ minHeight: '326px' }}>
        {footerComponent['Footer']}
      </div>
    </Observer>
  );
}

export default Footer;